module.exports = __webpack_public_path__ + "static/horizon_entire_page-b90d78861bfd0c760c3fc407cb578f6d.png";